
let nextSequenceId = -1 // Used to generate next sequence id
const sequences = [] // Sequences store
const states = [] // Used to store setTimeout ids of running sequences

/**
 * Runs sequence of functions with delays
 *
 * @param {Object[]} sequence - Array of function calls with corresonding delays { fn, delay }
 * @returns {number} sequenceId - Can be used to stop sequence
 */
export function runSequence (sequence) {
  if (!Array.isArray(sequence)) console.error('ERROR: runSequence - Argument must be an array of objects { fn, delay }')

  nextSequenceId++
  sequences[nextSequenceId] = [ ...sequence ]

  runNextFunction(nextSequenceId)

  return nextSequenceId
}

function runNextFunction (sequenceId) {
  const sequence = sequences[sequenceId]
  const action = sequence.shift()

  if (!action.hasOwnProperty('fn') || !action.hasOwnProperty('delay')) {
    console.error('ERROR: runSequence - Argument must be an array of objects { fn, delay }')
  }

  states[sequenceId] = setTimeout(
    () => {
      action.fn()
      if (sequence.length > 0) runNextFunction(sequenceId)
    },
    action.delay
  )
}
/**
 * Immediately stops corresonding sequence
 *
 * @param {number} sequenceId
 */
export function stopSequence (sequenceId) {
  if (typeof states[sequenceId] === 'number') {
    clearTimeout(states[sequenceId])
  }
}



// WEBPACK FOOTER //
// ./src/utils/sequence.js